module.exports = __webpack_public_path__ + "static/images/f501629e0b0b12becc3e354ab3231388.svg";